document.addEventListener('DOMContentLoaded', () => {

    const picker = document.querySelector('variant-picker');

    if (!picker) return;

    picker.addEventListener('variant:update', (event) => {

        const html = event.detail.data.html;

        const nuevo = html.querySelector('#variant-characteristics');
        const actual = document.querySelector('#variant-characteristics');

        if (nuevo && actual) {
            actual.innerHTML = nuevo.innerHTML;
        }

        const newCustomTitle = html.querySelector('.customtitle');
        const currentCustomTitle = document.querySelector('.customtitle');

        if(Boolean(newCustomTitle)){
            if(currentCustomTitle){
                currentCustomTitle.innerText = newCustomTitle.innerText;
            }
        }

    });

});